
import React from 'react'
import BiddingContractSubstep from './BiddingContractSubstep'

export default class BiddingContractDeliverablesSubstep extends BiddingContractSubstep
{
	static SubstepName = 'start_project.contract_deliverables.title';

	static TranslationKey = 'start_project.contract_deliverables';

	static SubstepSlug = 'deliverables';
    static path = '/deliverables';
	render()
	{
		let {project} = this.props;
		if (!project) {
			return <div/>
		}

		let groups = project.groupedDeliverablesByCategory();

		return (
			<div>
				{groups.map((category,i) => {
					return (
						<div key={`deliverableCategory${i}`}>
							<p style={{textAlign: 'left', fontWeight: 500, fontSize: 18, marginTop: 25}}>
								{category.name}
							</p>

							<hr/>

							{category.deliverables.map((deliverable,di) => (
								<div key={`category${i}deliverable${di}`}
									className="project-sow-deliverable-panel"
									style={{textAlign: 'left', marginTop: 25}}>

									<p style={styles.deliverableTitle}>
										{deliverable.name}
									</p>

									<div className="flex project-sow-deliverable-details-panel">

										<div style={styles.deliverableSection}
											className="pr-3">
											{TB.isString(deliverable.summary) && deliverable.summary.length && (
												<p style={styles.deliverableSectionTitle}>
													{this.trans('description_label')}
												</p>
											)}
											{TB.isString(deliverable.summary) && deliverable.summary.length && (
												<p style={{fontSize: 12, color: '#192A3E'}}>
													{deliverable.summary}
												</p>
											)}
										</div>

										<div style={styles.deliverableSection}
											className="px-3">
											{TB.isArray(deliverable.key_activities) && deliverable.key_activities.length > 0 && (
												<p style={styles.deliverableSectionTitle}>
													{this.trans('activities_label')}
												</p>
											)}
											{TB.isArray(deliverable.key_activities) && deliverable.key_activities.length > 0 && (
												<ul style={{...styles.deliverableSectionTitle, marginLeft: '15px'}}>
													{deliverable.key_activities.map((activity,ai) => (
														<li key={`category${i}deliverable${di}activity${ai}`}>
															{activity}
														</li>
													))}
												</ul>
											)}
										</div>

										<div style={styles.deliverableSection}
											className="pl-3">
											{TB.isArray(deliverable.key_assumptions) && deliverable.key_assumptions.length > 0 && (
												<p style={styles.deliverableSectionTitle}>
													{this.trans('assumptions_label')}
												</p>
											)}
											{TB.isArray(deliverable.key_assumptions) && deliverable.key_assumptions.length > 0 && (
												<ul style={{...styles.deliverableSectionTitle, marginLeft: '15px'}}>
													{deliverable.key_assumptions.map((assumption,ai) => (
														<li key={`category${i}deliverable${di}assumption${ai}`}>
															{assumption}
														</li>
													))}
												</ul>
											)}
										</div>
									</div>
								</div>
							))}
						</div>
					);
				})}
			</div>
    	);
	}
}


const styles = {
	deliverableTitle: {
		background: '#E5EBF1',
		padding: '3px 10px',
		display: 'inline-block',
		fontSize: 14,
		fontWeight: 500,
	},
	deliverableSection: {
		flex: 1,
		textAlign: 'left'
	},
	deliverableSectionTitle: {
		color: '#334D6E',
		fontSize: 12
	},
};